import PropTypes from "prop-types";
import { Box, Button, Chip, Tooltip, Typography } from "@mui/material";

const AdFormHeader = ({
  pageTitle,
  isViewMode,
  isEditMode,
  paymentLabel,
  paymentBadgeColor,
  isLimited,
  publishButtonLabel,
  hideSaveExit,
  onCancel,
  onSubmitAction,
  onEdit,
  canSave,
  canPublish,
}) => {
  const saveDisabled = !canSave;
  const publishDisabled = !canPublish;
  const saveTooltip = saveDisabled
    ? "Fill all required fields to enable Save & Exit."
    : "";
  let publishTooltip = "";
  if (publishDisabled) {
    publishTooltip =
      isLimited && !hideSaveExit
        ? "Ad already purchased — cannot publish again."
        : "Fill all required fields and upload an image for each selected device.";
  }
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={2}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="h6" fontWeight={700}>
          {pageTitle}
        </Typography>
        {(isEditMode || isViewMode) && (
          <Chip
            label={paymentLabel}
            color={paymentBadgeColor}
            variant="outlined"
            size="small"
          />
        )}
      </Box>

      <Box display="flex" gap={1.5}>
        {!isViewMode && (
          <>
            {!hideSaveExit && (
              <Tooltip
                title={saveTooltip}
                disableHoverListener={!saveDisabled}
              >
                <span>
                  <Button
                    variant="contained"
                    onClick={() => onSubmitAction("save")}
                    disabled={saveDisabled}
                  >
                    Save &amp; Exit
                  </Button>
                </span>
              </Tooltip>
            )}
            <Tooltip
              title={publishTooltip}
              disableHoverListener={!publishDisabled}
            >
              <span>
                <Button
                  variant="contained"
                  onClick={() => onSubmitAction("publish")}
                  disabled={publishDisabled}
                >
                  {publishButtonLabel}
                </Button>
              </span>
            </Tooltip>
          </>
        )}
        {isViewMode && onEdit && (
          <Button variant="contained" onClick={onEdit}>
            Edit
          </Button>
        )}
        <Button variant="outlined" onClick={onCancel}>
          {isViewMode ? "Close" : "Cancel"}
        </Button>
      </Box>
    </Box>
  );
};

AdFormHeader.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  isViewMode: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  paymentLabel: PropTypes.string.isRequired,
  paymentBadgeColor: PropTypes.string.isRequired,
  isLimited: PropTypes.bool.isRequired,
  publishButtonLabel: PropTypes.string,
  hideSaveExit: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmitAction: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  canSave: PropTypes.bool,
  canPublish: PropTypes.bool,
};

AdFormHeader.defaultProps = {
  publishButtonLabel: "Pay & Publish",
  hideSaveExit: false,
  onEdit: null,
  canSave: true,
  canPublish: true,
};

export default AdFormHeader;
